
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaiinnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Innova Crysta Cab',
        heading: 'Skyline Cabs: Pune to Mumbai Innova Crysta Cab',
        headingDescription: 'Skyline Cabs offers premium Pune to Mumbai Innova Crysta Cab services for a luxurious and comfortable ride. Ideal for family trips, business travel, or group outings, our spacious Innova Crysta cabs come with plush seating, ample luggage space, and top-notch amenities. Driven by professional chauffeurs and maintained to perfection, we ensure a smooth, safe, and stylish journey from Pune to Mumbai. Book your Innova Crysta with Skyline Cabs today and travel in comfort and class.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs offers a premium travel experience with Innova cabs from Pune to Mumbai. Ideal for business, family, or group travel, our Innova cabs come with spacious interiors, AC, and experienced drivers for a smooth, reliable journey."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova",
      "description": "Book your Innova Crysta for a stress-free airport drop from Pune to Mumbai with Skyline Cabs. Our vehicles ensure comfort, punctuality, and ample luggage space, making them perfect for airport travel."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Rent an Innova for a round trip or one-way travel between Pune and Mumbai with Skyline Cabs. Our flexible rental packages include fuel, driver, and tolls, ensuring complete transparency and comfort."
    },
    {
      "name": "Pune to Mumbai Airport Innova",
      "description": "Skyline Cabs provides clean and comfortable Innova Crysta taxis for Pune to Mumbai Airport transfers. We guarantee timely pickups, well-maintained vehicles, and courteous drivers for a relaxing journey."
    },
    {
      "name": "Innova Crysta on Rent Pune",
      "description": "Need an Innova Crysta for local or outstation trips from Pune? Skyline Cabs offers daily, hourly, and per-km rental options with experienced chauffeurs. Ideal for business meetings, family outings, or airport transfers."
    },
    {
      "name": "Pune to Mumbai One Way Innova Taxi",
      "description": "Travel from Pune to Mumbai in comfort with our one-way Innova taxi service. Skyline Cabs offers economical pricing and professional service, making it a popular choice for travelers heading to Mumbai."
    },
    {
      "name": "Pune to Mumbai Darshan Innova Taxi",
      "description": "Explore Mumbai’s iconic attractions in a day with our Pune to Mumbai Darshan Innova taxi package. Enjoy sightseeing in the comfort of a spacious vehicle with flexible pickup and drop-off points."
    },
    {
      "name": "Pune to Dadar Innova Taxi Fare",
      "description": "Skyline Cabs offers direct and affordable Innova taxi services from Pune to Dadar. Whether for business or personal travel, our spacious 7-seater cabs ensure a relaxed and efficient journey."
    },
    {
      "name": "Pune to Andheri Innova Crysta",
      "description": "Get a seamless travel experience from Pune to Andheri in a luxurious Innova Crysta with Skyline Cabs. Perfect for airport drops or business meetings, our cabs are available 24x7 with professional drivers."
    },
    {
      "name": "Pune to Mumbai Round Trip Innova Crysta",
      "description": "Skyline Cabs provides round trip packages from Pune to Mumbai in a comfortable Innova Crysta. Enjoy the convenience of returning the same day or extending your stay with our flexible rental options."
    },
    {
      "name": "Pune to Mumbai Airport Innova Crysta Cab",
      "description": "Book an Innova Crysta cab from Pune to Mumbai Airport with Skyline Cabs. Our reliable and spacious cabs are perfect for family or corporate airport transfers, available at competitive fares."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova",
      "description": "Skyline Cabs offers timely and affordable Innova Crysta airport drop services from Pune to Mumbai. Our drivers are punctual and courteous, ensuring a smooth journey to the terminal of your choice."
    },
    {
      "name": "Innova Hire in Pune",
      "description": "Looking to hire an Innova in Pune? Skyline Cabs provides well-maintained Innovas on rent with professional chauffeurs. Great for weddings, business events, outstation travel, and airport transfers."
    },
    {
      "name": "8 Seater Innova on Rent Pune",
      "description": "Skyline Cabs offers 8-seater Innova variants for hire in Pune. Ideal for large groups or families, our vehicles ensure a comfortable travel experience for long distances like Mumbai, Shirdi, and Lonavala."
    },
    {
      "name": "7 Seater Innova on Rent in Pune",
      "description": "Need a 7-seater Innova for rent in Pune? Skyline Cabs provides spacious and AC-enabled Innovas suitable for family travel, weekend trips, or city-to-city transfers like Pune to Mumbai."
    },
    {
      "name": "Innova Per KM Rate for Outstation",
      "description": "Skyline Cabs offers competitive per km rates for outstation Innova travel from Pune. Whether you're heading to Mumbai, Shirdi, or Goa, enjoy upfront pricing and flexible rental durations."
    },
    {
      "name": "Innova Crysta on Rent in Pimpri Chinchwad",
      "description": "Rent a premium Innova Crysta from Pimpri Chinchwad with Skyline Cabs. Our outstation and airport transfer packages include all charges with door-to-door pickup and drop-off service."
    },
    {
      "name": "Pune to Shirdi Innova Crysta Cab on Rent",
      "description": "Travel to Shirdi in comfort and style with Skyline Cabs' Innova Crysta rental service from Pune. Ideal for pilgrimages, our vehicles offer AC comfort, ample luggage space, and safe driving."
    },
    {
      "name": "Pune to Shirdi Innova Crysta Cab Booking Online",
      "description": "Easily book an Innova Crysta online for your Pune to Shirdi journey. Skyline Cabs offers flexible timing, transparent pricing, and reliable service with experienced drivers for a peaceful pilgrimage ride."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs is Pune's trusted cab provider for Innova and Ertiga rentals. Whether you need airport transfers, outstation rides, or luxury vehicle hire, we offer reliable service and transparent pricing 24x7."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Innova Cab", "Pune to Mumbai Airport Drop Innova"],
    ["Pune Mumbai Innova Rental", "Pune to Mumbai Airport Innova"],
    ["Innova Crysta on Rent Pune", "Pune to Mumbai One Way Innova Taxi"],
    ["Pune to Mumbai Darshan Innova Taxi", "Pune to Dadar Innova Taxi Fare"],
    ["Pune to Andheri Innova Crysta", "Pune to Mumbai Round Trip Innova Crysta"],
    ["Pune to Mumbai Airport Innova Crysta Cab", "Pune to Mumbai Airport Drop Innova"],
    ["Innova Hire in Pune", "8 Seater Innova on Rent Pune"],
    ["7 Seater Innova on Rent in Pune", "Innova Per KM Rate for Outstation"],
    ["Innova Crysta on Rent in Pimpri Chinchwad", "Pune to Shirdi Innova Crysta Cab on Rent"],
    ["Pune to Shirdi Innova Crysta Cab Booking Online", "Skyline Cabs Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Premium Pune to Mumbai Innova Crysta Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers top-notch Innova Crysta cab services from Pune to Mumbai for those who seek extra space, luxury, and reliability. Whether you’re traveling with family, colleagues, or a group of friends, the Innova Crysta provides the ideal balance of comfort and class."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors",
        "WhyChoosedescription": "The Innova Crysta is known for its plush interiors, captain seats (in select variants), and generous legroom. Travel in style and comfort on your Pune to Mumbai journey, with enough space to stretch out and relax—perfect for long-distance trips."
    },
    {
        "WhyChooseheading": "Ideal for Group and Family Travel",
        "WhyChoosedescription": "With seating for up to 6 passengers and ample luggage space, the Innova Crysta is a great choice for group travel. Whether it’s a vacation, a business trip, or a special occasion, everyone can ride together in comfort without compromising on space."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "Each Innova Crysta in our fleet is maintained to the highest standards, regularly serviced, and thoroughly cleaned before every ride. Enjoy a spotless, smooth, and safe journey with Skyline Cabs, every time you travel from Pune to Mumbai."
    },
    {
        "WhyChooseheading": "Trained and Professional Chauffeurs",
        "WhyChoosedescription": "Our drivers are courteous, experienced, and trained to deliver a premium travel experience. They know the Pune to Mumbai route inside out and focus on your safety and comfort throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Skyline Cabs provides clear and competitive pricing for Innova Crysta bookings. You'll receive upfront fare estimates with no hidden fees, allowing you to enjoy luxury travel without unexpected costs."
    },
    {
        "WhyChooseheading": "24/7 Availability and Instant Booking",
        "WhyChoosedescription": "Need to travel at an odd hour? No problem. Our Pune to Mumbai Innova Crysta cabs are available 24/7. Book easily via our website, app, or phone and receive instant confirmation with real-time tracking."
    },
    {
        "WhyChooseheading": "Safe and Secure Intercity Travel",
        "WhyChoosedescription": "Your safety is our top priority. All our Innova Crysta cabs are GPS-enabled and our drivers go through rigorous background checks. With Skyline Cabs, you can expect a safe, peaceful, and enjoyable ride every time you travel from Pune to Mumbai."
    }
]















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book an Ertiga cab from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Booking an Ertiga cab is simple through our website or mobile app. Select Pune as your pickup, Mumbai as your destination, and choose “Ertiga” under vehicle options. You can also book by calling our support team.',
        },
        {
            id: 2,
            question: 'Why choose an Ertiga for Pune to Mumbai travel?',
            answer:
                'The Ertiga is ideal for families and small groups. It offers ample legroom, luggage space, and a comfortable ride for long-distance travel. It’s the perfect mix of space and economy.',
        },
        {
            id: 3,
            question: 'Is the fare for Ertiga cabs fixed from Pune to Mumbai?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent pricing. The fare includes tolls, driver allowance, and taxes — with no hidden charges.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round trip in an Ertiga?',
            answer:
                'Yes, we provide both one-way and round-trip bookings in Ertiga cabs. Simply choose the option that suits your travel plan during booking.',
        },
        {
            id: 5,
            question: 'Is there enough luggage space in an Ertiga for a family?',
            answer:
                'Yes, the Ertiga is known for its spacious boot and roof storage (on request). It can easily handle luggage for up to 6 passengers.',
        },
        {
            id: 6,
            question: 'Are Ertiga cabs air-conditioned?',
            answer:
                'Absolutely! All our Ertiga vehicles are fully air-conditioned and maintained for optimal comfort.',
        },
        {
            id: 7,
            question: 'Can I pre-book an Ertiga cab in advance?',
            answer:
                'Yes, we recommend pre-booking Ertiga cabs for peak travel days or early morning journeys to ensure availability.',
        },
        {
            id: 8,
            question: 'Are your Ertiga cab drivers trained for intercity routes?',
            answer:
                'Yes, our drivers are experienced with Pune-Mumbai highway routes and prioritize safe, smooth, and punctual travel.',
        },
        {
            id: 9,
            question: 'Is Ertiga suitable for airport transfers to Mumbai?',
            answer:
                'Definitely. The Ertiga is a great choice for airport transfers, especially if you have multiple passengers and luggage. We ensure timely pickups and drop-offs.',
        },
        {
            id: 10,
            question: 'Why book Ertiga with Skyline Cabs?',
            answer:
                'Skyline Cabs offers clean, well-maintained Ertiga vehicles with trained drivers and honest pricing. It’s the perfect balance of comfort and cost-efficiency for your Pune to Mumbai journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rohit Sawant",
            rating: 5,
            review: "We booked an Ertiga for our Pune to Mumbai trip, and it was a great experience. The cab was spacious and clean, perfect for our family of five. The driver was polite and drove safely the whole way."
        },
        {
            name: "Miss. Rucha Nair",
            rating: 4,
            review: "I was traveling with friends, and the Ertiga from Skyline Cabs was a great choice. It had plenty of room for us and our bags. The ride was smooth and comfortable. Would love a built-in charging point next time!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Innova Crysta Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-innova-crysta-cab.jpg",
  "description": "Book Pune to Mumbai Innova Crysta cab with Skyline Cabs for a luxurious and spacious ride. Enjoy 6/7-seater AC travel with ample luggage space, ideal for families and corporate groups.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8137"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1900",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-innova-crysta-cab"
  }
};



      
     
      

    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Innova Crysta Cab | Spacious 6/7-Seater Ride | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Innova Crysta cab with Skyline Cabs for a luxurious and spacious ride. Enjoy 6/7-seater AC travel with ample luggage space, ideal for families and corporate groups." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Innova Crysta Cab, Innova Crysta Booking Pune to Mumbai, 7-Seater SUV Cab Pune Mumbai, Family Cab Pune to Mumbai, AC Innova Crysta Pune Mumbai, Pune to Mumbai Luxury Taxi, Spacious Cab Pune to Mumbai, Corporate Cab Pune to Mumbai, Skyline Cabs Innova Pune to Mumbai, Pune Mumbai Innova One Way" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiinnovacrysta;